<template>
  <div id="app">
    <router-view />

    <el-dialog :visible.sync="openDemoDialog" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" class="demo-dialog" :before-close="handleClose">
      <div>
        <div v-if="!is_demo_booked">
          <div class="font-07rem text-center">Please select a date and time to book the demo</div>
          <div class="top-margin-10">
            <el-row>
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <v-date-picker :value="demo_date" :attributes="attributes" :disabled-dates="disabledDates" ref="calendar" color="red" :min-date="min_date" is-inline @dayclick="dayChange($event)" />
              </el-col>

              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-loading="is_time_slots_loading">
                <!-- available time slots section -->
                <div v-if="!is_demo_already_booked">
                  <div class="font-07rem top-margin-15 text-center" style="color: #000">AVAILABLE TIME SLOTS</div>
                  <div class="top-margin-15">
                    <el-row v-if="time_slots.length">
                      <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-for="(slot, time_index) in time_slots" :key="time_index">
                        <div
                          size="mini"
                          class="time-slot-tag cursor-pointer"
                          effect="plain"
                          type="info"
                          @click="selectTimeSlot(slot.slot_time)"
                          :class="[selected_time_slot == slot.slot_time ? 'selected-time-slot' : '']"
                          :style="[
                            !slot.is_available
                              ? {
                                  borderColor: '#ddd',
                                  color: '#ddd',
                                  pointerEvents: 'none',
                                }
                              : 'pointer',
                          ]"
                        >
                          {{ slot.slot_time }}
                        </div>
                      </el-col>
                    </el-row>

                    <div>
                      <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20" v-if="!is_time_slots_loading && !time_slots.length">Select date to get time slots</div>
                    </div>
                  </div>

                  <div style="border-bottom: 1px solid #ddd">&nbsp;</div>

                  <div class="top-margin-10" v-if="selected_time_slot">
                    <el-row v-if="demo_date">
                      <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" class="responsive-tabs">
                        <div class="date">
                          {{ moment(demo_date).format('DD') }}
                          <sup>{{ moment(demo_date).format('DD') | day_filter }}</sup>
                        </div>

                        <div class="label-xs-black font-weight-600" style="color: #000">
                          {{ moment(demo_date).format('MMMM') }}
                        </div>

                        <div class="input-label-gray">
                          {{ moment(demo_date).format('YYYY') }}
                        </div>
                      </el-col>

                      <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" v-if="selected_time_slot" class="responsive-tabs">
                        <div class="label-xs-black font-weight-600" style="color: #000">
                          {{ moment(demo_date).format('dddd') }}
                        </div>

                        <div class="date right-margin-20">
                          {{ selected_time_slot }}
                        </div>

                        <div class="input-label-gray">UTC +05:30 IST</div>
                      </el-col>

                      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="text-center" v-if="selected_time_slot">
                        <el-button class="btn-gradient top-margin-10" size="mini" @click="bookDemo()" :loading="is_book_demo_btn_loading">Book</el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <!-- already booked demo -->
                <div v-if="is_demo_already_booked">
                  <div class="font-07rem top-margin-15 text-center" style="color: #000">ALREADY BOOKED DEMO</div>

                  <div class="top-margin-15 text-center" style="height: 150px; overflow: auto">
                    <el-row v-if="booked_demo_list.length">
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(demo, demo_index) in booked_demo_list" :key="demo_index">
                        <div class="top-margin-10">
                          <span style="color: #409eff">{{ demo.date }}</span>
                          &nbsp;
                          <span style="color: #409eff" v-if="demo.slot">{{ demo.slot.slice(0, 5) }}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <span class="primary-theme-color cursor-pointer" @click="selectBookedTimeSlot(demo)"><i class="el-icon-edit"></i></span>
                          &nbsp;&nbsp;
                          <span class="primary-theme-color cursor-pointer" @click="cancelDemo(demo)"><i class="el-icon-delete-solid"></i></span>
                        </div>
                        <!-- <div size="mini" class="time-slot-tag cursor-pointer" effect="plain" type="info" @click="selectTimeSlot(slot.slot_time)" :class="[selected_time_slot == slot.slot_time ? 'selected-time-slot' : '']" :style="[ !slot.is_available ? { borderColor: '#ddd', color: '#ddd', pointerEvents: 'none' } : 'pointer' ]">
                          {{ slot.slot_time }}
                        </div> -->
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!-- section to show after demo is successfully booked-->
        <div v-if="is_demo_booked">
          <div class="text-center">
            <i class="el-icon-circle-check primary-theme-color" style="font-size: 40px"></i>
          </div>

          <div class="top-margin-10">
            <div class="font-08rem text-center" style="color: #000">Your StockAnts demo session is booked!</div>

            <div style="border: 1px solid #e72726; padding: 15px 30px; margin: 20px 30px; border-radius: 10px">
              <div v-if="selected_time_slot">
                <el-row v-if="demo_date">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="responsive-tabs">
                    <div class="font-09rem top-margin-20 bottom-margin-10">Session Details :</div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" class="responsive-tabs">
                    <div class="date">
                      {{ moment(demo_date).format('DD') }}
                      <sup>{{ moment(demo_date).format('DD') | day_filter }}</sup>
                    </div>

                    <div class="label-xs-black font-weight-600" style="color: #000">
                      {{ moment(demo_date).format('MMMM') }}
                    </div>

                    <div class="input-label-gray">
                      {{ moment(demo_date).format('YYYY') }}
                    </div>
                  </el-col>

                  <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" v-if="selected_time_slot" class="responsive-tabs">
                    <div class="label-xs-black font-weight-600" style="color: #000">
                      {{ moment(demo_date).format('dddd') }}
                    </div>

                    <div class="date right-margin-20">
                      {{ selected_time_slot }}
                    </div>

                    <div class="input-label-gray">UTC +05:30 IST</div>
                  </el-col>
                </el-row>
              </div>
            </div>

            <div style="display: flex; justify-content: space-evenly">
              <el-button class="action-btn" size="mini" @click="checkBookedDemo()">Reschedule</el-button>
              <el-button class="dismiss-btn" size="mini" @click="closeDemoDialog()">Dismiss</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="openSubscribePlanNotificationDialog" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" class="subscribe-plan-notification-dialog" :before-close="closeNotificationModal">
      <div class="flex-space-between flex-wrap">
        <div>
          <div class="label-lg-black-bold">Paid Feature.</div>
          <div class="label-xs-black top-margin-5" v-if="$route.path != '/pricing'">To get access visit plans section.</div>
          <div v-else>To get access subscribe to Premium plan</div>
        </div>

        <div class="top-margin-10">
          <el-button round class="select-plan" size="mini" @click="goToPricingPage()" v-if="$route.path != '/pricing'">CHECK PLANS</el-button>

          <el-button v-else round class="select-plan" size="mini" @click="closeNotificationModal">OKAY</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="openBrokerDialog" :close-on-click-modal="true" :close-on-press-escape="true" :lock-scroll="true" class="new-plan-notification-dialog" :before-close="closeBrokerLoginModal">
      <div class="broker-card-main">
        <img class="logo" src="../src/assets/images/logo/logo1.png" alt="" />
        <!-- <div class="head">Login through broker</div> -->
        <div class="search-input" v-if="brokers_list.length > 1">
          <el-input placeholder="Search your broker" size="mini" prefix-icon="el-icon-search" v-model="broker_search_query" clearable></el-input>
        </div>

        <div class="text-center font-09rem font-weight-600 broker-card-outer">
          <div class="flex-center flex-wrap" style="justify-content: space-between">
            <div class="flex-center flex-wrap" style="justify-content: space-between" v-if="userProfile">
              <div v-for="(broker, index) in filtered_brokers" :key="index" class="broker-card" v-if="broker.model_type != 'STOCKANTS_AUTH' && broker.is_trading_available">
                <div class="flex-center cursor-pointer" @click="getRedirectURLForBroker(broker)" v-if="broker.title != 'Zerodha'">
                  <img :src="serverHostName + '/' + broker.logo" style="width: 35px" />
                  <div class="font-07rem font-weight-600 left-margin-10" :style="[broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                    {{ broker.title }}
                  </div>
                </div>

                <div class="flex-center cursor-pointer" v-if="broker.title == 'Zerodha' && !isStrategyExpired" id="kite-button">
                  <img :src="serverHostName + '/' + broker.logo" style="width: 35px" />
                  <div class="font-07rem font-weight-600 left-margin-10" :style="[broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                    {{ broker.title }}
                  </div>
                </div>
              </div>
            </div>
            <div class="flex-center flex-wrap" style="justify-content: space-between" v-else>
              <div v-for="(broker, index) in filtered_brokers" :key="index" class="broker-card" v-if="broker.model_type != 'STOCKANTS_AUTH'">
                <div class="flex-center cursor-pointer" @click="getRedirectURLForBroker(broker)" v-if="broker.title != 'Zerodha'">
                  <img :src="serverHostName + '/' + broker.logo" style="width: 35px" />
                  <div class="font-07rem font-weight-600 left-margin-10" :style="[broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                    {{ broker.title }}
                  </div>
                </div>

                <div class="flex-center cursor-pointer" v-if="broker.title == 'Zerodha' && !isStrategyExpired" id="kite-button">
                  <img :src="serverHostName + '/' + broker.logo" style="width: 35px" />
                  <div class="font-07rem font-weight-600 left-margin-10" :style="[broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                    {{ broker.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="openHybridBrokerDialog" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" class="new-plan-notification-dialog" :before-close="closeHybridBrokerDialog">
      <div class="broker-card-main">
        <img class="logo" src="../src/assets/images/logo/logo1.png" alt="" />
        <div class="head">Continue with your trading account</div>

        <div class="text-center font-09rem font-weight-600 broker-card-outer">
          <div class="flex-center flex-wrap">
            <div class="hybrid-broker-card">
              <div class="flex cursor-pointer inner-card" @click="goToTradeLink(hybrid_broker.redirect_url.sign_in)">
                <img :src="serverHostName + '/' + hybrid_broker.logo" />
                <div class="font-1rem font-weight-600 left-margin-15" :style="[hybrid_broker.title == 'Show More' ? { marginTop: '12px', color: '#2d2e8d' } : {}]">
                  {{ hybrid_broker.title }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center top-margin-10">
          <div style="width: 20%; display: inline-block; border-bottom: 1px solid #ddd"></div>
          <div style="width: 10%; display: inline-block; font-size: 0.9rem; color: #9b9898; position: relative; top: 4px">Or</div>
          <div style="width: 20%; display: inline-block; border-bottom: 1px solid #ddd"></div>
        </div>
        <div class="text-left" style="color: #191919; padding: 10px" v-if="getSubscribedPlanDetails.length && getSubscribedPlanDetails.plan != 'Premium' && getSubscribedPlanDetails.plan != 'Pro'">
          <p class="font-weight-600 font-08rem">Don't have a broker Account?</p>
          <div class="label-xs-bold">Skip Broker login and Subscribe Premium Plan</div>
          <div class="top-margin-5 required-field font-06rem font-weight-500">(No Trade Allowed)</div>
          <el-button class="btn-secondary-theme-filled" style="width: 90%; margin: 10px auto" @click="goToPricingPage()">Subscribe Now</el-button>
        </div>
        <div v-else>
          <el-button class="btn-theme-filled" style="width: 90%; margin: 20px auto; padding: 10px 15px" @click="goToTradeLink(hybrid_broker.redirect_url.sign_up)">Open Demat Account</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- new chat request dialog -->
    <div class="chat-request-popup">
      <el-dialog :visible.sync="newChatRequestDialogVisible" class="feedback-popup feedback-two" :show-close="false" :close-on-click-modal="false" v-if="$route.path !== '/chat'">
        <div class="popup-content">
          <div>New Chat Request from {{ newChatRequestObj.second_user_details ? newChatRequestObj.second_user_details.full_name : 'User' }}</div>

          <div class="top-margin-10">
            <el-button
              class="btn-light-blue-filled"
              style="width: 100px"
              @click="
                $router.push('/chat');
                newChatRequestDialogVisible = false;
              "
              :loading="requestLoader"
            >
              Go To Chat
            </el-button>
            <el-button class="btn-light-blue-filled" style="width: 100px" @click="denyChatRequestDialog" :loading="isRequestCanceling">Deny</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="logo-container" v-if="userProfile != null && $route.path !== '/stockants-overview' && isAdmin && ($route.path == '/data-categorisation' || $route.path == '/experts-past-recommendations' || $route.path == '/expert-view-lite')" style="cursor: pointer">
      <img @click="$router.push('/stockants-overview')" src="../src/assets/images/stockantsoverview/SA-Overview-Icon-removebg-preview (2).png" alt="Logo" class="overview-logo" />
    </div>
  </div>
</template>

<script>
import { serverAddr, serverHostName } from './networkConfig';
import moment from 'moment';
import CripNotice from 'crip-vue-notice';
import { HelperNetworkCallBack } from './mixins/Helper';
import { fcmNotification } from './mixins/fcmNotification';
// import socket from './mixins/WebSocket.js';
import { updateProfileNetworkCallBack } from './mixins/UpdateProfile.NetworkCallBack';
import { json } from 'sjcl';
import { debounce } from 'lodash';

export default {
  mixins: [HelperNetworkCallBack, updateProfileNetworkCallBack, fcmNotification],
  components: {},

  data() {
    return {
      serverHostName: serverHostName,
      request_demo_visibility: false,
      is_demo_booked: false,
      is_demo_already_booked: false,
      otp_validate_dialog_visible: false,
      // is_kyc_popup_visible: false,
      is_kyc_Completed_popup_visible: false,
      openHybridBrokerDialog: false,
      time_slots: [],
      booked_demo_list: [],
      demo_date: '',
      min_date: new Date().setDate(new Date().getDate() + 2),
      moment: moment,
      selected_time_slot: '',
      disabledDates: { weekdays: [1, 7] },
      is_time_slots_loading: false,
      is_book_demo_btn_loading: false,
      brokers_list: [],
      attributes: [
        {
          key: 'today',
          highlight: false,
        },
      ],
      edit_booked_demo: {},
      is_loading: false,
      userProfile: null,
      recentPath: '',
      planSubscriptionStatusDetails: null,
      subscription_agreement: true,
      term_and_condition: true,
      allow_notification: true,
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      hybrid_broker: [],
      broker_search_query: '',
      filtered_brokers: [],

      isAdmin: false,
      kite: null, // To hold the KiteConnect instance
      isStrategyExpired: false,

      recentUsers: [],
      newChatRequestDialogVisible: false,
      isRequestCanceling: false,
      requestLoader: false,
    };
  },

  filters: {
    day_filter(i) {
      if (i) {
        var j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return 'st';
        }
        if (j == 2 && k != 12) {
          return 'nd';
        }
        if (j == 3 && k != 13) {
          return 'rd';
        }
        return 'th';
      }
    },
  },

  watch: {
    openBrokerDialog(newValue) {
      if (newValue) {
        if (this.userProfile) {
          this.filtered_brokers = this.brokers_list;
        } else {
          var brokers_list_for_presignup = this.brokers_list.filter((item) => item.title !== 'Zerodha');
          this.filtered_brokers = brokers_list_for_presignup;
        }
        this.loadKitePublisherScript();
      }
    },
    broker_search_query(newTitle) {
      const lowerCaseFilter = newTitle.toLowerCase();

      if (this.userProfile) {
        this.filtered_brokers = this.brokers_list.filter((obj) => obj.title.toLowerCase().includes(lowerCaseFilter));
      } else {
        // Remove zerodha from presign up popup
        var brokers_list_for_presignup = this.brokers_list.filter((item) => item.title !== 'Zerodha');
        this.filtered_brokers = brokers_list_for_presignup.filter((obj) => obj.title.toLowerCase().includes(lowerCaseFilter));
      }
    },

    openDemoDialog(newValue, oldValue) {
      if (newValue) {
        this.demo_date = '';
        this.reRescheduleDemo();
      }
    },
    getPlanSubscriptionStatus(newValue, oldValue) {
      this.planSubscriptionStatusDetails = newValue.message;

      if (this.planSubscriptionStatusDetails && this.planSubscriptionStatusDetails.extra_info.transaction_status == 'SUCCESS') {
        if (this.planSubscriptionStatusDetails.data.plan == 'Publisher') {
          localStorage.setItem('publisher_plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        } else {
          localStorage.setItem('plan_details', JSON.stringify(this.planSubscriptionStatusDetails.data));
        }

        this.$store.commit('commitKycDialog', true);
      }
    },
    getHybridBrokerDetails(newValue, oldValue) {
      if (newValue == true) {
        this.getTradeHostDetails();
      } else if (newValue == false) {
        this.openHybridBrokerDialog = false;
      }
    },

    $route() {
      // Call on route change
      var profile = JSON.parse(localStorage.getItem('profile'));
      if (profile != null) {
        this.setupSocketListeners();
      }
    },
  },

  beforeCreate() {
    if (localStorage.getItem('profile')) {
      setTimeout(() => {
        var websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};
        var userProfile = JSON.parse(localStorage.getItem('profile'));

        var internalTeamList = ['krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com'];

        userProfile.email = userProfile.email.toLowerCase();

        if (websiteUserType && websiteUserType.userType == 'stockAnts' && internalTeamList.includes(userProfile.email)) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  created() {
    this.$root.$on('updatedProfileData', () => {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    });
  },

  mounted() {
    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    }

    if (!this.brokers_list.length) {
      this.getBrokersList();
    }

    document.addEventListener('visibilitychange', () => {
      console.log('Visibility changed:', document.visibilityState, this.$socket);
      if (document.visibilityState === 'visible') {
        if (this.$socket && !this.$socket.connected) {
          console.log('Tab is active again. Attempting to reconnect socket...');
          // this.$initChatSocket(); // this will now work because of Vue.prototype.$initChatSocket

          // this.$socket.connect();
        }
      }
    });

    // this.filtered_brokers = this.brokers_list;

    // Get the profile from localStorage, Below code for pagesense tracking api
    // const profile = JSON.parse(localStorage.getItem('profile'));

    if (!localStorage.getItem('fcm_token')) {
      this.initFCM();
    }

    // Determine the identifier to use for PageSense
    let identifier = '';

    if (this.userProfile != null) {
      this.setUserTypeForChat();
      this.setupSocketListeners();

      if (this.userProfile.full_name) {
        identifier = this.userProfile.full_name;
      } else if (this.userProfile.email) {
        identifier = this.userProfile.email;
      } else if (this.userProfile.user) {
        identifier = this.userProfile.user;
      }
    }
    if (window && window.pagesense) {
      // Initialize PageSense with the identifier
      window.pagesense = window.pagesense || [];
      window.pagesense.push(['identifyUser', identifier]);
    }
    this.selectUserType();

    this.$store.commit('commitQRCodePopup', false);
  },

  methods: {
    setupSocketListeners() {
      this.$socket.off('recent-chat');

      this.$socket.emit('get_recent_chat', { user_id: this.userProfile.id }, (ack) => {});

      this.$socket.on('recent-chat', (data) => {
        console.log('recent-chat1234', data);
        this.recentUsers = [];

        if (data.data.length) {
          for (let i = 0; i < data.data.length; i++) {
            this.recentUsers.push(data.data[i]);
          }

          this.$store.commit('commitRecentUsers', this.recentUsers);

          let filteredRequestedUser = this.recentUsers.find((e) => e.status_str === 'Requested');

          if (filteredRequestedUser && this.$route.path !== '/chat' && (this.userType == 'Active RA' || this.userType == 'Non Active RA')) {
            this.$store.commit('commitRoomId', filteredRequestedUser.title);
            this.$store.commit('commitNewChatRequestObj', filteredRequestedUser);
            setTimeout(() => {
              this.newChatRequestDialogVisible = true;
            }, 1000);
          }
        }
      });
    },

    setUserTypeForChat() {
      if (this.userProfile.profession == 'Retail Investor') {
        this.userType = 'Retail Investor';
      } else if (this.userProfile.is_active_ra) {
        this.userType = 'Active RA';
      } else if (!this.userProfile.is_active_ra) {
        this.userType = 'Non Active RA';
        this.nonActiveRaPopupVisible = true;
      }
    },

    denyChatRequestDialog() {
      this.isRequestCanceling = true;
      return new Promise((resolve, reject) => {
        this.$socket.emit('cancel_room_status', { room: this.newChatRequestObj.title, user_id: this.newChatRequestObj.retail_user_id });

        resolve(true); // Resolve the promise with acknowledgment data

        this.newChatRequestDialogVisible = false;
        this.isRequestCanceling = false;
      });

      // this.$store.commit('commitNewChatRequestDialogState', false);
    },
    // Dynamically load the Kite Publisher script
    loadKitePublisherScript() {
      const script = document.createElement('script');
      script.src = 'https://kite.trade/publisher.js?v=3';
      script.async = true;
      script.onload = this.initKitePublisher; // Run after script loads
      document.head.appendChild(script);
    },

    // Initialize Kite Publisher after the script is loaded
    initKitePublisher() {
      if (typeof KiteConnect === 'undefined') {
        console.error('KiteConnect not found. Script failed to load.');
        return;
      }

      // Ensure Kite Publisher is ready before running code
      KiteConnect.ready(() => {
        this.kite = new KiteConnect('s8r229rs5vrd6yzn');
        var tradeStockDetails = this.$store.state.selected_order;
        if (tradeStockDetails.segment == 'equity') {
          this.kite.add({
            tradingsymbol: tradeStockDetails.symbol,
            exchange: 'BSE', // or "NSE"
            transaction_type: tradeStockDetails.order_type == 'Buy' ? 'BUY' : 'SELL',
            order_type: 'LIMIT', // LIMIT order
            price: tradeStockDetails.ltp,
            quantity: 10,
          });

          // Render the Kite button for equity trades
          this.kite.renderButton('#kite-button');
        }

        console.log(this.kite);

        if (tradeStockDetails.segment == 'options') {
          this.kite.add({
            exchange: 'NFO', // NFO for Options
            tradingsymbol: tradeStockDetails.stock.symbol, // Options symbol
            transaction_type: tradeStockDetails.order_type, // BUY or SELL
            order_type: 'LIMIT', // LIMIT order
            price: tradeStockDetails.stock.ltp,
            quantity: tradeStockDetails.stock.lot_size,
          });

          // Render the Kite button for equity trades
          this.kite.renderButton('#kite-button');
        }

        // Optional callback when the basket interaction is done
        this.kite.finished((status, request_token) => {
          this.closeBrokerLoginModal();
          if (status == 'cancelled') {
            new CripNotice({
              description: 'Order is cancelled',
              type: 'info',
              duration: 3,
            });
          }
        });
      });
    },

    downloadSubscriptionAgreement() {
      window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
    },

    getRedirectURLForBroker(broker) {
      // this.logOut()
      localStorage.setItem('selected_broker', broker.id);
      if (broker.id) {
        serverAddr
          .get(`auth/v1/level_one_auth_for_broker?broker_id=${broker.id}`)
          .then((response) => {
            if (response.data.status) {
              window.location.href = response.data.data.redirect_url;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (broker.id == 21 || broker.id == 22) {
        window.location.href = '/login';
      }
    },
    getBrokersList() {
      serverAddr
        .post('/auth/v1/broker/list', {
          // page_source: this.UserType,
        })
        .then((response) => {
          if (response.data.status && response.data.data.length) {
            this.brokers_list = response.data.data;

            // this.allowed_authentication = response.data.auth_option;

            // Call the new method to load PageSense scripts for each broker
            this.loadPageSenseScriptsForBrokers(this.filtered_brokers);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadPageSenseScriptsForBrokers(brokers) {
      brokers.forEach((broker) => {
        if (broker.broker_name) {
          this.loadPageSenseScript(broker.broker_name);
        }
      });
    },

    loadPageSenseScript(brokerName) {
      const script = document.createElement('script');
      script.src = `https://cdn-in.pagesense.io/js/${brokerName}/65622f1d1add41ffa8c72a60556bb0de.js`;
      script.async = true;
      document.head.appendChild(script);
    },
    goToPricingPage() {
      this.closeBrokerLoginModal();
      // closed dialog before going on pricing page
      this.$store.commit('commitSubscribPlanDialogVisibility', false);

      localStorage.setItem('premiumPlanSubscriptionDialogVisible', true);

      this.$router.push({ path: '/pricing' });
    },

    // close modal -- store visibiltiy in vue store
    closeNotificationModal() {
      this.$store.commit('commitSubscribPlanDialogVisibility', false);
    },

    // close modal -- store visibiltiy in vue store
    closeBrokerLoginModal() {
      this.$store.commit('commitBrokerLoginDialogVisibility', false);
    },

    closeHybridBrokerDialog() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', false);
    },

    // called function on dismiss btn click
    closeDemoDialog() {
      this.$store.commit('commitDialogVisibility', false);
      this.is_demo_booked = false;
    },

    // on rescdule demo btn click reset all fields
    reRescheduleDemo() {
      this.time_slots = [];
      this.selected_time_slot = '';
      // this.demo_date = '';
      this.is_demo_booked = false;
      this.is_demo_already_booked = false;
      this.edit_booked_demo = {};
      this.booked_demo_list = [];
    },

    selectBookedTimeSlot(demo) {
      this.edit_booked_demo = demo;
      // this.demo_date = new Date(demo.date);
      this.getDemoTimeSlots();
      this.is_demo_already_booked = false; //switch
    },

    // stored in store boolean value --- to close demo dialog
    closeDemoDialog() {
      this.$store.commit('commitDialogVisibility', false);
    },

    // api to check already booked demo
    checkBookedDemo() {
      this.reRescheduleDemo();

      this.is_time_slots_loading = true;

      serverAddr
        .get('/stockants_pro/request_demo_detail/', {})
        .then((response) => {
          if (response.data.status) {
            //if any time slots are booked then displayed already booked demo section
            if (response.data.data.length) {
              response.data.data.forEach((element) => {
                let time = `${element.date} ${element.slot}`;

                //checked is current time is lower than slot time then pushed obj
                if (moment().isBefore(time, 'hour')) {
                  this.booked_demo_list.push(element);
                }
              });

              // if all booked demos are out of current date then called get time slots api
              if (this.booked_demo_list.length) {
                this.is_demo_already_booked = true; //to switch is already demo booked section
                this.is_time_slots_loading = false;
              } else {
                this.getDemoTimeSlots();
              }

              //if any time slots are not booked then called get time slots api
            } else {
              this.is_demo_already_booked = false;
              this.getDemoTimeSlots();
            }
          } else {
            this.booked_demo_list = [];
            this.is_demo_already_booked = false;
            this.getDemoTimeSlots();
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.booked_demo_list = [];
            this.is_time_slots_loading = false;

            this.closeDemoDialog(); //if network call fails then closed dialog
          }.bind(this)
        );
    },

    //get experts details
    getDemoTimeSlots() {
      this.is_time_slots_loading = true;
      this.selected_time_slot = '';

      serverAddr
        .post('/stockants_pro/get_request_demo_slot/', {
          date: moment(this.demo_date).format('YYYY-MM-DD'),
        })
        .then((response) => {
          if (response.data.status) {
            this.is_time_slots_loading = false;
            this.time_slots = response.data.data;

            // if selected time slot to reschedule
            if (Object.keys(this.edit_booked_demo).length) {
              //  this.selected_time_slot =  this.edit_booked_demo.slot.slice(0, 5);
              //  this.demo_date = new Date(this.edit_booked_demo.date);
            }
          } else {
            this.time_slots = [];
            this.is_time_slots_loading = false;
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_time_slots_loading = false;
          }.bind(this)
        );
    },

    bookDemo() {
      this.is_book_demo_btn_loading = true;
      serverAddr
        .post('/stockants_pro/create-request-demo/', {
          appointment: `${moment(this.demo_date).format('YYYY-MM-DD')} ${this.selected_time_slot}`,
          status: this.edit_booked_demo.status ? this.edit_booked_demo.status : 'new',
          id: this.edit_booked_demo.id ? this.edit_booked_demo.id : null,
        })
        .then((response) => {
          if (response.data.status) {
            this.is_book_demo_btn_loading = false;

            this.is_demo_booked = true;

            new CripNotice({
              title: 'Success',
              description: 'Demo has been booked',
              type: 'success',
              duration: 3,
            });

            // this.$store.commit('commitDialogVisibility', false);
          } else {
            this.is_book_demo_btn_loading = false;
            this.is_demo_booked = false;
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_book_demo_btn_loading = false;
            this.is_demo_booked = false;
          }.bind(this)
        );
    },

    cancelDemo(demo) {
      this.is_time_slots_loading = true;

      serverAddr
        .post('/stockants_pro/create-request-demo/', {
          appointment: `${demo.date} ${demo.slot.slice(0, 5)}`,
          status: 'cancel',
          id: demo.id,
        })
        .then((response) => {
          if (response.data.status) {
            this.checkBookedDemo();

            new CripNotice({
              title: 'Success',
              description: 'Demo has been canceled',
              type: 'success',
              duration: 3,
            });

            // this.$store.commit('commitDialogVisibility', false);
          } else {
            this.is_time_slots_loading = false; //disabled loader
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_time_slots_loading = false; //disabled loader
          }.bind(this)
        );
    },

    dayChange: _.debounce(function (el) {
      //checked is date is disabled or not if disabled then not updating v-model
      // and assigning previously selected date to v-model
      if (!Object.keys(el.isDisabled).length) {
        this.demo_date = el.date;

        this.checkBookedDemo();
        // this.getDemoTimeSlots();
      } else {
        this.demo_date = this.demo_date;
      }
    }, 500),

    // function to disable time slots
    //if current time is greater less than 30 minutes and greater than time slot then disabled
    checkIsTimeSloctDisable(time) {
      let now = new Date();
      now.setHours('11');
      now.setMinutes('29');

      var start_time = time.split(':');

      let hours = new Date().setHours(start_time[0]);

      let minutes = new Date(hours).setMinutes(Number(start_time[1]) - 30);

      var d = new Date();

      if (new Date(now).getTime() >= new Date(minutes).getTime()) {
        return true;
      }

      return false;
    },

    selectTimeSlot(time) {
      this.selected_time_slot = time;
    },

    handleClose() {
      this.$store.commit('commitDialogVisibility', false);
      // this.request_demo_visibility = false;
    },

    getUserProfile() {
      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },
    goToTradeLink(link) {
      this.closeHybridBrokerDialog();
      window.open(link, '_blank');
    },
    downloadPdf(pdf) {
      if (pdf == 'agreement') {
        window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
      } else {
        window.open(`${this.serverHostName}/Media/important_doc/termsAndConditions.pdf`, '_blank');
      }
    },

    getTradeHostDetails() {
      if (Object.keys(this.hybrid_broker).length === 0) {
        var broker_id = null;
        var currentEnvironment = {};
        if (localStorage.getItem('currentEnvironment')) {
          currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
          broker_id = currentEnvironment.brokerId;
        }
        if (broker_id != null) {
          serverAddr
            .get(`/auth/v1/hybrid/redirection?broker_id=${broker_id}`)
            .then((response) => {
              if (response.status) {
                var data = response.data.data;
                this.hybrid_broker = data;
                this.openHybridBrokerDialog = true;
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        this.openHybridBrokerDialog = true;
      }
    },
    downloadSubscriptionAgreement() {
      window.open(`${this.serverHostName}/Media/important_doc/StockAntsSubscriptionAgreement.pdf`, '_blank');
    },
  },

  computed: {
    roomId() {
      return this.$store.state.room_id;
    },
    
    newChatRequestObj() {
      return this.$store.state.newChatRequestObj;
    },

    getSelectedOrder() {
      return this.$store.state.selected_order;
    },

    openDemoDialog() {
      return this.$store.state.visible_demo_dialog;
    },

    openSubscribePlanNotificationDialog() {
      if (this.websiteUserType && this.websiteUserType.userSubType != 'brokerWithoutPlans') {
        return this.$store.state.is_subscribe_plan_dialog_visible;
      }
    },

    openBrokerDialog() {
      return this.$store.state.is_login_through_broker_dialog_visible;
    },
    getHybridBrokerDetails() {
      return this.$store.state.is_login_through_hybrid_broker_dialog_visible;
    },

    getSubscribedPlanDetails() {
      return this.$store.state.subscribed_plan_details;
    },

    getPlanSubscriptionStatus() {
      return this.$store.state.planStatus;
    },
  },

  beforeDestroy() {
    // this.$socket.off('recent-chat');
  },
};
</script>

<style lang="scss">
@import './css/common.scss';
@import './css/variable.scss';

.kite-trade-button {
  position: absolute;
  // right: 10px;
  width: 130px !important;
  height: 45px !important;
  background: none !important;
}

.plan-notification-dialog {
  .el-dialog {
    border-radius: 11px;
    width: 350px;
    border-bottom: 5px solid #0ba042;
  }

  .el-dialog__body,
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    text-align: center;
  }

  .dialog-content {
    padding: 20px;
    word-break: break-word;
  }

  .container {
    width: 100%;
    height: 100px;
    border-radius: 11px 11px 0px 0px;
    background: #079e3e;
    background: radial-gradient(circle, rgba(7, 158, 62, 1) 74%, rgba(18, 163, 71, 1) 80%, rgba(25, 190, 86, 1) 1090%);
  }

  .green-btn {
    color: #079e3e;
    border: 1px solid #079e3e;
  }

  .green-btn:hover {
    border: 1px solid #079e3e;
    background-color: #079e3e;
    color: #ffff;
  }

  .gift-image {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    height: 70px;
    width: 70px;
  }

  .overlay-message {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    font-size: 1.1rem;
    color: white;
    font-weight: 600;
    margin-top: 15px;
    padding: 10px 0;
  }

  .congratulations {
    margin-top: 35px;
  }

  .congratulations-message {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 15px;
    color: rgb(77, 161, 67);
  }

  .centered-line {
    width: 100px;
    margin: 0 auto 20px auto;
    border: 0;
    border-top: 2px solid #ece7e7;
  }

  .plan-status {
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #2a2a2a;
    margin-bottom: 0px;
  }

  .plan-status p {
    margin: 5px 0;
  }
}

.logo-container {
  position: fixed;
  bottom: 55px;
  right: 30px;
  z-index: 1000;
  /* z-index is higher than other elements */
}

.overview-logo {
  width: 50px;
  height: auto;
}

.faded-border-bottom {
  display: block;
  border: none;
  color: #fff;
  height: 1px;
  background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 450, from(#f1f1f1), to(#fff));
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}

@media screen and (max-width: 900px) {
  .unsubscribe-plan-notification-dialog .el-dialog {
    width: 90%;
  }
}

.broker-card-main {
  text-align: center;
  word-break: normal;

  .btn-secondary-theme-filled {
    border-radius: 5px !important;
    font-weight: 500;
  }

  .btn-secondary-theme-filled:hover {
    // color: $secondary-theme-color;
  }

  .logo {
    width: 180px;
    // margin-bottom: 20px;
  }

  .head {
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
  }

  .broker-card-outer::-webkit-scrollbar {
    width: 2px;
  }

  .broker-card-outer::-webkit-scrollbar-track {
    // box-shadow: inset 0 0 5px #bababa;
    // border-radius: 5px;
  }

  /* Handle */
  .broker-card-outer::-webkit-scrollbar-thumb {
    background: #c3c3c3;
    border-radius: 10px;
  }

  /* Handle on hover */
  .broker-card-outer::-webkit-scrollbar-thumb:hover {
    // background: #b30000;
  }

  .broker-card-outer {
    margin-top: 20px;
    max-height: 280px;
    overflow-y: scroll;

    .broker-card {
      display: flex;
      align-items: center;
      text-align: left;
      width: 120px;
      margin: 10px;
      padding: 10px;
      height: 30px;
      border-radius: 8px;
      box-shadow: 0 2px 12px 0 #09090947;

      .el-card__body {
        padding: 10px 15px !important;
      }

      // img{
      //   width: 30px;
      // }
    }
  }
}

.hybrid-broker-card {
  img {
    width: 120px;
  }

  .inner-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 15px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.2);
    margin: 15px 0;
  }
}

body,
html {
  // height: 100%;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

#app {
  height: 100%;
  box-sizing: border-box;
}

.el-loading-spinner .path {
  stroke: $secondary-theme-color !important;
  stroke-width: 6px !important;
}

.el-loading-spinner .circular {
  width: 30px !important;
  height: 30px !important;
}

@keyframes shake {
  10%,
  90% {
    transform: translate(-1px, 0);
  }

  20%,
  80% {
    transform: translate(2px, 0);
  }

  30%,
  50%,
  70% {
    transform: translate(-4px, 0);
  }

  40%,
  60% {
    transform: translate(4px, 0);
  }
}

.form-group--error input,
.form-group--error textarea,
.form-group--error input:focus,
.form-group--error input:hover {
  border-color: #f79483;
}

.form-group__message,
.error {
  font-size: 0.75em;
  line-height: 1;
  display: none;
  margin: 5px 4px;
}

.error-text {
  color: red;
  font-size: 0.75em;
  line-height: 1;
  margin: 5px 4px;
}

.form-group--alert,
.form-group--error {
  animation-name: shake;
  animation-duration: 0.6s;
  animation-timing-function: ease-in-out;
}

.form-group--error + .form-group__message,
.form-group--error + .error {
  display: block;
  color: red;
}

.form-group__message,
.error {
  display: none;
}

.el-dialog__body {
  word-break: normal !important;
}

// demo dialog and calendar css start
.new-mobile-email-verification-dialog {
  .agree-text {
    color: #409eff;
    text-decoration: underline;
  }

  .el-dialog {
    width: 350px;
    border-radius: 8px;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding-top: 10px;
    text-align: center;
  }
}

.demo-dialog {
  .el-dialog {
    border-radius: 10px;
    width: 60%;
  }

  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #909399 !important;
  }

  .el-dialog__body {
    padding: 10px 20px 20px 20px;
  }

  .time-slot-tag {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    color: #000;
    font-size: 11px;
    font-weight: 500;
    padding: 0px 10px;
    margin: 5px;
    height: 20px;
    width: 40px;
    border: 1px solid #000;
  }

  .selected-time-slot {
    color: #fff;
    font-weight: 500;
    background-color: $primary-theme-color;
    border: 1px solid $primary-theme-color;
  }

  .date {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }

  .btn-gradient {
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    width: 100px;
    outline: none;
    border-radius: 25px;
    color: #fff;
    font-size: 13px;
    border: none;
    cursor: pointer;
  }

  .btn-gradient:hover {
    color: #fff;
    transition: 0.4s ease;
    box-shadow: 0px 0px 10px -1px #dc6250;
  }

  .action-btn {
    background-color: #fff;
    width: 100px;
    outline: none;
    border-radius: 25px;
    color: $primary-theme-color;
    font-size: 13px;
    border-color: $primary-theme-color;
    cursor: pointer;
    margin: 10px;
  }

  .dismiss-btn {
    background-color: #fff;
    width: 100px;
    outline: none;
    border-radius: 25px;
    color: #ddd;
    font-size: 13px;
    border-color: #ddd;
    cursor: pointer;
    margin: 10px;
  }

  .vc-border {
    border-width: 0px !important;
  }

  .vc-title {
    font-size: 12px !important;
    padding: 5px !important;
  }

  .vc-day-content:focus {
    // background-image: linear-gradient(to left, #dc6250, #eb5151);
    // background-color: $primary-theme-color!important;
  }

  .vc-text-gray-400 {
    background-color: #fff !important;
    cursor: not-allowed;
  }

  .vc-weekday {
    color: #000 !important;
    font-weight: 400 !important;
  }

  .vc-text-sm {
    font-size: 12px !important;
  }

  .vc-svg-icon {
    height: 20px !important;
  }
}

.new-plan-notification-dialog {
  .search-input {
    width: 90%;
    margin: auto;

    .el-input__inner {
      border-radius: 15px;
    }

    .el-icon-search {
      position: relative;
      top: -1px;
    }
  }

  .el-dialog {
    border-radius: 10px;
    width: 370px;
    margin-top: 30px !important;
    margin-bottom: 0 !important;
  }

  .el-dialog__body {
    padding: 20px;
  }

  .el-dialog__header {
    padding: 0;
  }
}

@media screen and (max-width: 992px) {
  .demo-dialog {
    .el-dialog {
      width: 85%;
    }

    .responsive-tabs {
      text-align: center;
    }
  }
}

.subscribe-plan-notification-dialog {
  .el-dialog {
    border-radius: 10px;
    width: 35%;
  }

  .el-dialog__body {
    padding: 10px 20px 20px 20px;
  }

  .select-plan {
    background-image: linear-gradient(to left, #dc6250, #eb5151);
    color: #fff;
    border: none;
    font-size: 12px;
    height: 25px;
    line-height: 0.8;
    // width: 250px;
  }

  .select-plan:hover {
    color: #fff;
  }
}

@media screen and (max-width: 1050px) {
  .subscribe-plan-notification-dialog {
    .el-dialog {
      width: 70%;
    }
  }
}

@media screen and (max-width: 880px) {
  .crip-notices {
    width: fit-content !important;
    top: unset !important;
    bottom: 0 !important;
    right: 0 !important;
    left: 0 !important;
    margin: 0 auto !important;
  }

  .crip-notice {
    background: #000 !important;
    padding: 0 !important;
  }

  .crip-notice-content.crip-notice-with-desc .crip-notice-icon {
    display: none;
  }

  .crip-notice-title {
    display: none;
  }

  .crip-notice-content.crip-notice-with-icon.crip-notice-with-desc .crip-notice-desc,
  .crip-notice-content.crip-notice-with-icon.crip-notice-with-desc .crip-notice-title {
    color: #fff;
    padding: 10px;
    margin-left: 0 !important;
  }

  .crip-notice-success:after {
    background: #000 !important;
  }

  .crip-notice-error:after {
    background: #000 !important;
  }
}

@media screen and (max-width: 768px) {
  .vc-container {
    margin: 0 auto;
  }
}

@media screen and (max-width: 390px) {
  .plan-notification-dialog {
    .el-dialog {
      width: 95%;
    }
  }

  .new-plan-notification-dialog {
    .el-dialog {
      width: 97%;
    }

    .el-dialog__body {
      padding: 10px;
    }
  }

  .broker-card-main .broker-card-outer .broker-card {
    width: 110px;
    margin: 10px 5px;
    padding: 10px;
  }
}
</style>

<style lang="scss">
@import './css/common.scss';
@import './css/variable.scss';

.chat-request-popup {
  .feedback-popup {
    .popup-content {
      padding: 20px 25px;
      text-align: center;
    }

    .el-dialog {
      width: 350px;
      border-radius: 10px;
      margin-top: 120px !important;
    }

    .el-dialog__header {
      padding: 7px;
      background-color: #2488ff;
      border-radius: 10px 10px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}

/* montserrat-300 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 300;
  src: url('./assets/font/montserrat1/montserrat-v14-latin-300.eot');
  /* IE9 Compat Modes */
  src: local('Montserrat Light'), local('Montserrat-Light'), url('./assets/font/montserrat1/montserrat-v14-latin-300.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/font/montserrat1/montserrat-v14-latin-300.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-300.woff') format('woff'), /* Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-300.ttf') format('truetype'), /* Safari, Android, iOS */ url('./assets/font/montserrat1/montserrat-v14-latin-300.svg#Montserrat') format('svg');
  /* Legacy iOS */
}

/* montserrat-regular - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/font/montserrat1/montserrat-v14-latin-regular.eot');
  /* IE9 Compat Modes */
  src: local('Montserrat Regular'), local('Montserrat-Regular'), url('./assets/font/montserrat1/montserrat-v14-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/font/montserrat1/montserrat-v14-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-regular.woff') format('woff'), /* Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */ url('./assets/font/montserrat1/montserrat-v14-latin-regular.svg#Montserrat') format('svg');
  /* Legacy iOS */
}

// /* montserrat-500 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  src: url('./assets/font/montserrat1/montserrat-v14-latin-500.eot');
  /* IE9 Compat Modes */
  src: local('Montserrat Medium'), local('Montserrat-Medium'), url('./assets/font/montserrat1/montserrat-v14-latin-500.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/font/montserrat1/montserrat-v14-latin-500.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-500.woff') format('woff'), /* Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-500.ttf') format('truetype'), /* Safari, Android, iOS */ url('./assets/font/montserrat1/montserrat-v14-latin-500.svg#Montserrat') format('svg');
  /* Legacy iOS */
}

// /* montserrat-600 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  src: url('./assets/font/montserrat1/montserrat-v14-latin-600.eot');
  /* IE9 Compat Modes */
  src: local('Montserrat SemiBold'), local('Montserrat-SemiBold'), url('./assets/font/montserrat1/montserrat-v14-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/font/montserrat1/montserrat-v14-latin-600.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-600.woff') format('woff'), /* Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */ url('./assets/font/montserrat1/montserrat-v14-latin-600.svg#Montserrat') format('svg');
  /* Legacy iOS */
}

// /* montserrat-700 - latin */
@font-face {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  src: url('./assets/font/montserrat1/montserrat-v14-latin-700.eot');
  /* IE9 Compat Modes */
  src: local('Montserrat Bold'), local('Montserrat-Bold'), url('./assets/font/montserrat1/montserrat-v14-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('./assets/font/montserrat1/montserrat-v14-latin-700.woff2') format('woff2'), /* Super Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-700.woff') format('woff'), /* Modern Browsers */ url('./assets/font/montserrat1/montserrat-v14-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */ url('./assets/font/montserrat1/montserrat-v14-latin-700.svg#Montserrat') format('svg');
  /* Legacy iOS */
}

// style for hubspot message box
#hubspot-messages-iframe-container {
  z-index: 2 !important;
}

.p-top-8 {
  padding-top: 0;
}

.kgoSCU {
  padding: 0;
}

iframe {
  border: 1px solid #ddd;
}
</style>